import { useEffect, useState } from 'react';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function TextEditor(porps) {

    const [firstTime, setFirstTime] = useState(false)

    const {
        value = "",
        onChange = () => {}
    } = porps

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    const handleChange = (e) => {
        if(firstTime){
            onChange(e)
        } else {
            setFirstTime(true)
        }
    }

    return (
        <div className='text-editor-modal textEditorInModal rtl-editor'>
            <ReactQuill 
                theme="snow" 
                value={value} 
                onChange={handleChange} 
                modules={modules}
                formats={formats}
            />
        </div>
    )
}
